import { Platform, StatusBar } from 'react-native'

const colours = {
  black: '#1e242b',
  white: 'white',
  primary: '#12a9f9',
  secondary: '#fb8c23',
  third: '#2da9b2',
  lightgrey: '#f7f7f7',
  mediumgrey: '#f4f4f4',
  grey: '#d5d5d5',
  darkgrey: '#727f92',
  bordergrey: '#a9a9a9',
  error: '#721c24',
  orange: '#ef8018',
  blue: '#38a9e4',
  magenta: '#c15b9e',
  aqua: '#50c4cd',
  green: '#36bd85',
  red: '#d70005',
  purple: '#5d69bc',
  darkBlue: '#4d95b6',
  active: '#c6edff',
  success: '#24ff00',
  chart: {
    blue: '#93d8fc', // '#28b1f9',
    orange: '#fb8d23'
  }
}

const fonts = {
  primary: 'ubuntu-medium'
}

const gutterUnit = 10
const headerHeight = 80
const teamBarHeight = 50
const statusBarHeight = Platform.OS === 'ios' ? 20 : Platform.OS === 'web' ? 0 : StatusBar.currentHeight

export default {
  colours,
  fonts,
  gutterUnit,
  headerHeight,
  teamBarHeight,
  statusBarHeight,
  paginationHeight: 40,
  businesses: {
    titleHeight: 40,
    labelHeight: 45
  }
}
